var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _c(
        "v-dialog",
        {
          staticClass: "del",
          attrs: {
            name: "dialog2",
            title: _vm.dialogTitle,
            "close-on-click-modal": "",
            modal: true,
            width: 668,
            height: 274,
            "append-to-body": "",
            confirmButtonText: this.delete,
          },
          on: {
            "after-close": _vm.handleAfterClose,
            confirm: _vm.handleConfirm,
          },
          model: {
            value: _vm.isShow,
            callback: function ($$v) {
              _vm.isShow = $$v
            },
            expression: "isShow",
          },
        },
        [_vm._v(" 确定删除全部日志吗？ ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }